<template>
  <div class="control-group">
    <label :for="inputId">
      <img :src="icon" :alt="label + ' icon'" class="icon" />
      {{ label }}
    </label>
    <div class="slider-wrapper">
      <input
        :id="sliderId"
        type="range"
        :min="SLIDER_CONFIG.MIN_PERCENT"
        :max="SLIDER_CONFIG.MAX_PERCENT"
        :step="SLIDER_CONFIG.STEP"
        :value="sliderValue"
        class="slider"
        :style="sliderStyles"
        @input="onSliderInput"
      />
      <input
        :id="inputId"
        :type="isCustomValue ? 'text' : 'number'"
        :min="minValue"
        :max="maxValue"
        :value="displayValue"
        class="number-input"
        @input="onInputChange"
        :readonly="isCustomValue"
      />
    </div>
  </div>
</template>

<script>
import { SLIDER_CONFIG } from '../constants/slider'
import { getRealValue, getSliderPercent, SCALES } from '../utils/scales'
import { getDisplayValue, isCustomValue } from '../utils/sliderDisplay'

export default {
  name: 'ControlSlider',

  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    scaleName: {
      type: String,
      required: true,
      validator: value => Object.keys(SCALES).includes(value)
    },
    // Optional unique identifier for multiple sliders
    uniqueId: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      SLIDER_CONFIG
    }
  },

  computed: {
    scale() {
      return SCALES[this.scaleName]
    },

    minValue() {
      return this.scale[0][1]
    },

    maxValue() {
      return this.scale[this.scale.length - 1][1]
    },

    sliderValue() {
      return getSliderPercent(this.value, this.scaleName)
    },

    sliderStyles() {
      const percentage = this.sliderValue
      // Normalize to 0-100% range for visual display (since slider goes to 105)
      const visualPercentage =
        (percentage / SLIDER_CONFIG.MAX_PERCENT) *
        SLIDER_CONFIG.VISUAL_MAX_PERCENT
      return {
        '--progress-percentage': `${visualPercentage}%`
      }
    },

    sliderId() {
      return this.uniqueId
        ? `${this.scaleName}-slider-${this.uniqueId}`
        : `${this.scaleName}-slider`
    },

    inputId() {
      return this.uniqueId
        ? `${this.scaleName}-value-${this.uniqueId}`
        : `${this.scaleName}-value`
    },

    isCustomValue() {
      return isCustomValue(this.value)
    },

    displayValue() {
      return getDisplayValue(this.value)
    }
  },

  methods: {
    onSliderInput(event) {
      const percent = parseFloat(event.target.value)
      const realValue = getRealValue(percent, this.scaleName)
      this.$emit('input', realValue)
    },

    onInputChange(event) {
      let realValue = parseInt(event.target.value) || 0

      // Prevent exceeding min/max if typing manually
      if (realValue < this.minValue) realValue = this.minValue
      if (realValue > this.maxValue) realValue = this.maxValue

      this.$emit('input', realValue)
    }
  }
}
</script>

<style>
/* Styles to /assets/scss/components/pricing.scss */
</style>
